import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/react/dist/esm/components/box/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/button/button.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/react/dist/esm/components/button/icon-button.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/react/dist/esm/components/center/center.js");
;
import(/* webpackMode: "eager", webpackExports: ["ClientOnly"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/client-only/client-only.js");
;
import(/* webpackMode: "eager", webpackExports: ["CollapsibleContent","CollapsibleContext","CollapsibleIndicator","CollapsiblePropsProvider","CollapsibleRoot","CollapsibleRootProvider","CollapsibleTrigger"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/collapsible/collapsible.js");
;
import(/* webpackMode: "eager", webpackExports: ["Icon"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/icon/icon.js");
;
import(/* webpackMode: "eager", webpackExports: ["Link"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/link/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["MenuArrow","MenuArrowTip","MenuCheckboxItem","MenuContent","MenuContext","MenuContextTrigger","MenuIndicator","MenuItem","MenuItemCommand","MenuItemContext","MenuItemGroup","MenuItemGroupLabel","MenuItemIndicator","MenuItemText","MenuPositioner","MenuRadioItem","MenuRadioItemGroup","MenuRoot","MenuPropsProvider","MenuRootProvider","MenuSeparator","MenuTrigger","MenuTriggerItem"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/menu/menu.js");
;
import(/* webpackMode: "eager", webpackExports: ["ProgressContext","ProgressLabel","ProgressPropsProvider","ProgressRange","ProgressRoot","ProgressRootProvider","ProgressTrack","ProgressValueText"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/progress/progress.js");
;
import(/* webpackMode: "eager", webpackExports: ["Separator"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/separator/separator.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/react/dist/esm/components/skeleton/skeleton.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/react/dist/esm/components/stack/h-stack.js");
;
import(/* webpackMode: "eager", webpackExports: ["Stack"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/stack/stack.js");
;
import(/* webpackMode: "eager", webpackExports: ["VStack"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/stack/v-stack.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/react/dist/esm/components/text/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["ClientNextThemeProvider"] */ "/app/node_modules/@wrksz/themes/dist/providers/client-next-provider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/local/target.css?{\"path\":\"src/styles/fonts.proprietary.ts\",\"import\":\"\",\"arguments\":[{\"src\":[{\"path\":\"./fonts/TTNormsPro/TT_Norms_Pro_Light.woff2\",\"weight\":\"300\",\"style\":\"normal\"},{\"path\":\"./fonts/TTNormsPro/TT_Norms_Pro_Light_Italic.woff2\",\"weight\":\"300\",\"style\":\"italic\"},{\"path\":\"./fonts/TTNormsPro/TT_Norms_Pro_Regular.woff2\",\"weight\":\"400\",\"style\":\"normal\"},{\"path\":\"./fonts/TTNormsPro/TT_Norms_Pro_Medium.woff2\",\"weight\":\"500\",\"style\":\"normal\"},{\"path\":\"./fonts/TTNormsPro/TT_Norms_Pro_Bold.woff2\",\"weight\":\"700\",\"style\":\"normal\"},{\"path\":\"./fonts/TTNormsPro/TT_Norms_Pro_Condensed_ExtraBold.woff2\",\"weight\":\"800\",\"style\":\"normal\"}],\"declarations\":[{\"prop\":\"ascent-override\",\"value\":\"105%\"},{\"prop\":\"descent-override\",\"value\":\"-33%\"}]}],\"variableName\":\"ttNormsPro\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/styles/fonts.ts\",\"import\":\"Rubik\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"googleFont\"}");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/nextjs-toploader/dist/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/BetaDisclaimer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/AboutTheRegulationsIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/AboutTheWcaIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/AdminResultsIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/AllCompsIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/BookmarkIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/CloneIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/CompetitorsIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/CompNotStartedIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/CompRegoClosed_redIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/CompRegoCloseDateIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/CompRegoClosedIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/CompRegoFullButOpen_orangeIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/CompRegoFullButOpenIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/CompRegoNotFullOpen_greenIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/CompRegoNotFullOpenIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/CompRegoNotOpenYet_greyIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/CompRegoNotOpenYetIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/CompRegoOpenDateIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/ContactIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/DelegateReportIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/DetailsIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/DeveloperExportIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/DisciplinaryLogIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/DisclaimerIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/DownloadIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/EditIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/EducationalResourcesIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/ErrorIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_222Icon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_333bfIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_333fmIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_333ftIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_333Icon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_333mbfIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_333mboIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_333ohIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_444bfIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_444Icon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_555bfIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_555Icon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_666Icon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_777Icon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_ClockIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_FtoIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_MagicIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_MinxIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_MmagicIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_PyramIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_SkewbIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_Sq1Icon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/ExternalLinkIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/FacebookIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/FiltersIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/GithubIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/GuidelinesIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/HelpAndFaqsIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/IncidentsLogIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/InformationIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/InstagramIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/LanguageIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/ListIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/LocationIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/ManageTabsIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/MapIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/MediaSubmissionIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/MenuIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/MultimediaIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/MyCompsIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/MyResultsIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/NationalChampionshipIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/NewCompIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/OnTheSpotRegistrationIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/PaymentIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/PrivacyIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/RankingsIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/RecordsIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/RegionalOrganisationsIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/RegisterIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/RegistrationIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/RegulationsAndGuidelinesIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/RegulationsHistoryIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/RegulationsIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/ResultsExportIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/ScramblesIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/SearchIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/SpectatorsIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/SpeedcubingHistoryIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/SpotsLeftIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/StatisticsIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/TeamsCommitteesAndCouncilsIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/ToolsIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/TranslatorsIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/TwitchIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/UserIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/UsersPersonsIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/VenueIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/WcaDelegatesIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/WcaDocsIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/WcaLiveIcon.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/icons/WcaLogoIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/WcaOfficersAndBoardIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/WeiboIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/XIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/YoutubeIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileNavRoot","MobileNavLink","MobileNavButton"] */ "/app/src/components/MobileNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RefreshRouteOnSave"] */ "/app/src/components/RefreshRouteOnSave.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/SearchBar/WcaSearch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ui/avatarMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ColorModeButton"] */ "/app/src/components/ui/color-mode.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EmotionRegistry"] */ "/app/src/components/ui/emotion-registry.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ui/languageSelector.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Provider"] */ "/app/src/components/ui/provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/src/components/ui/toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/providers/WCAQueryClientProvider.tsx");
